import { render, staticRenderFns } from "./project-join.vue?vue&type=template&id=022af914&"
import script from "./project-join.vue?vue&type=script&lang=ts&"
export * from "./project-join.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports